export const getSmsConsentMessage = (
  buttonName: "Pay" | "Send Request" | "Reserve"
) =>
  `By clicking “${buttonName}” you agree to receive order updates via SMS. Messages & data rates may apply. You can also opt out of receiving text messages at any time by replying STOP.`;
